import { useTranslation } from "@/i18n/use-t";

// Build-time identity injected by vite.config.ts.
declare const __APP_VERSION__: string;
declare const __APP_BUILD__: string;

export function AppFooter() {
  const { t } = useTranslation("common");
  const version = __APP_VERSION__;
  const build = __APP_BUILD__;
  return (
    <footer
      data-print-hide
      className="mt-12 border-t border-border bg-background/60"
    >
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-2 px-4 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div className="space-y-1">
          <p className="font-semibold text-foreground">{t("footer.brand")}</p>
          <p>{t("footer.tagline")}</p>
        </div>
        <div className="space-y-1 sm:text-right">
          <p>{t("footer.privacyNote")}</p>
          {version && (
            <p className="font-mono text-[10px] uppercase tracking-widest">
              v{version}
              {build ? <> · {build}</> : null}
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
